export const MODULE_ALLOW_NESTED_ADVANCED_FILTER = [
  'productInformation',
  'oNIXPublicationFileInformation',
  'alcoholInformation',
  'allergenInformation',
  'animalFeeding',
  'apparelInformation',
  'audienceOrPlayerInformation',
  'audioVisualMediaContentInformation',
  'audioVisualMediaProductDescriptionInformation',
  'audioVisualMediaProductionInformation',
  'awardPrize',
  'batteryInformation',
  'certificationInformation',
  'chemicalRegulationInformation',
  'childNutritionInformation',
  'consumerInstructions',
  'controlledSubstance',
  'copyrightInformation',
  'dairyFishMeatPoultryItem',
  'dangerousSubstanceInformation',
  'deliveryPurchasingInformation',
  'dietInformation',
  'durableGoodsCharacteristics',
  'dutyFeeTaxInformation',
  'electronicDeviceCharacteristicsInformation',
  'farmingAndProcessingInformation',
  'foodAndBeverageIngredient',
  'foodAndBeveragePreparationServing',
  'foodAndBeveragePropertiesInformation',
  'healthcareItemInformation',
  'healthRelatedInformation',
  'healthWellnessPackagingMarking',
  'lightingDevice',
  'marketingInformation',
  'medicalDeviceTradeItem',
  'movieRevenueInformation',
  'nonfoodIngredient',
  'nonGTINLogisticsUnitInformation',
  'organismClassification',
  'packagingInformation',
  'packagingMarking',
  'packagingSustainability',
  'sustainability',
  'pharmaceuticalItemInformation',
  'physicalResourceUsageInformation',
  'placeOfItemActivity',
  'plumbingHVACPipeInformation',
  'productCharacteristics',
  'productFormulationStatement',
  'promotionalItemInformation',
  'propellantInformation',
  'publicationTitleRating',
  'referencedFileDetailInformation',
  'regulatedTradeItem',
  'safetyDataSheet',
  'salesInformation',
  'securityTagInformation',
  'softwareSystemRequirements',
  'textileMaterial',
  'tradeItemDataCarrierAndIdentification',
  'tradeItemDescription',
  'tradeItemDisposalInformation',
  'tradeItemHandling',
  'tradeItemHumidityInformation',
  'tradeItemLicensing',
  'tradeItemLifespan',
  'tradeItemMeasurements',
  'tradeItemSize',
  'tradeItemTemperatureInformation',
  'transportationHazardousClassification',
  'variableTradeItemInformation',
  'videoDisplayDeviceInformation',
  'warrantyInformation',
  'opticsDeviceInformation',
  'tradeItemHierarchy',
  'nutritionalInformation',
  'qaSpecification',
  'supplementInformation',
  'drugInformation',
];

export const MAXIMUM_QUERY_CONDITIONS = 50;
export const MAXIMUM_DATA_COLUMNS = 200;

export const DEFAULT_OPERATION = 'OR';

export const ADVANCED_FILTER_MODE = {
  NESTED_DATA: 'nested-data',
  FLAT_DATA: 'flat-data',
};

export const ADD_QUERY = {
  FILTER: 'FILTER',
  GROUP: 'GROUP',
};

export const UPDATE_COLUMNS = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  UPDATE: 'UPDATE',
  CLEAR: 'CLEAR',
  UP: 'UP',
  DOWN: 'DOWN',
};

export const FIELDS_CHANGED = [
  'fieldsChanged.fieldPath',
  'fieldsChanged.lastChanged',
];

export const APL_FIELDS = ['aplQuery.searchSet'];

export const INITIAL_SEARCH_SET_CONDITION = {
  operation: 'OR',
  isNestedContainer: false,
  children: [
    {
      id: 'b31b9252-1d72-4c32-8667-5ac0e258b163',
      fieldName: 'aplQuery.searchSet',
      operator: 'Equal',
      value: null,
      children: null,
    },
  ],
  strictMode: false,
  advancedFilterMode: 'flat-data',
  fieldName: null,
};
export const DELIVERY_METHOD = ['email', 'ftp'];
export const REPORT_EXPORT_TYPE_ADVANCED = ['XLS', 'XLSX', 'JSON', 'XML'];
export const REPORT_EXPORT_TYPE_FLAT = ['XLS', 'XLSX', 'CSV', 'JSON', 'XML'];
